import { render, staticRenderFns } from "./SeriesBlockNew.vue?vue&type=template&id=34c624fc&"
import script from "./SeriesBlockNew.vue?vue&type=script&lang=js&"
export * from "./SeriesBlockNew.vue?vue&type=script&lang=js&"
import style0 from "./SeriesBlockNew.vue?vue&type=style&index=0&id=34c624fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports